import { ElNotification } from 'element-ui'
import Profile from './../store/modules/Profile'

export const ajaxErrorHandlerMap = {
  401: () => {
    Profile.mutations.removeToken()
  },
  408: (ajaxError) => {
    ajaxErrorHandlerMap[401](ajaxError)
  },
  417: (ajaxError) => {
    ElNotification.error({
      title: '错误',
      message: ajaxError.message,
      position: 'bottom-right'
    })
  },
  500: (ajaxError) => {
    ElNotification.error({
      title: '错误',
      message: ajaxError.message,
      position: 'bottom-right'
    })
  }
}

export const ajaxErrorHandler = (ajaxError) => {
  const errorHandler = ajaxErrorHandlerMap[ajaxError.code]
  errorHandler ? errorHandler(ajaxError) : ajaxErrorHandlerMap[500](ajaxError)
}



// WEBPACK FOOTER //
// ./src/utils/AjaxErrorHandler.js